/*
 * fn: trackPageview
 *
 *  Tracks a pageview for each page load
 *
 */
import ReactGA from 'react-ga4'

import { IS_ANALYTICS_ENABLED } from '@/defs/analytics'

export const trackPageview = (page: string) => {
  if (!IS_ANALYTICS_ENABLED) return

  ReactGA.send({ hitType: 'pageview', page })
}
